<template>
    <div class="edit-favorites">
        <h3>{{ $TL.editFavorite }}</h3>
        <div class="edit-slot">
            <p>{{ $TL.favoriteName }}</p>
            <input
                type="text"
                class="input-control"
                v-model="name"
                @input="edit_name"
                maxlength="50"
            />
        </div>
        <div class="operate-btm">
            <v-btn
                :class="['save-btn def', isSave && 'gradient-bg']"
                @click="save_favor_name"
            >
                {{ $TL.save }}
            </v-btn>
            <v-btn class="cancel-btn def" @click="cancel">{{
                $TL.cancel
            }}</v-btn>
            <v-btn class="remove-favor-btn def" @click="remove_favor">{{
                $TL.deleteFavorites
            }}</v-btn>
        </div>
    </div>
</template>

<script>
import { editFavoritesName } from "@/api/interface.js";
import { mapMutations, mapState } from "vuex";
export default {
    name: "edit-favorites",

    data() {
        return {
            name: "",
            isSave: false
        };
    },
    computed: {
        ...mapState("favorites", ["favoritesId", "favoritesName"])
    },
    created() {
        this.name = this.favoritesName;
    },
    methods: {
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),
        edit_name() {
            this.isSave = this.name.trim() === "" ? false : true;
        },
        cancel() {
            this.$P.$emit("closeModal");
        },
        remove_favor() {
            this.$store.state.vModal.showType = "removeFavorite";
        },
        async save_favor_name() {
            try {
                await editFavoritesName(this.favoritesId, {
                    name: this.name
                });
                this.$P.$emit(
                    "updateFavoritesName",
                    this.name,
                    this.favoritesId
                );
                this.$P.$emit("closeModal");
                this.updateSnackbar(this.$TL.favoriteNameModifiedSuccess);
            } catch (e) {
                if (e?.response.status === 400) {
                    const errors = e.response.data.message;
                    this.updateSnackbar(errors);
                }
            }
        }
    }
};
</script>

<style lang="scss">
.editFavorites {
    .v-dialog {
        width: 400px;
    }
}
.edit-favorites {
    padding: 12px;

    .edit-slot {
        margin-top: 16px;

        p {
            margin: 0;
            font-size: 14px;
            color: #595959;
        }

        .input-control {
            width: 100%;
            border-color: #e9e9e9;
        }
    }

    .operate-btm {
        margin-top: 16px;
        .v-btn {
            display: inline-block;
        }

        .save-btn {
            background-color: #e8e8e8;
            color: $color-white;
        }

        .cancel-btn {
            margin-left: 8px;
        }

        .remove-favor-btn {
            float: right;
            border: 1px solid #e9e9e9;
            transition: all 0.3s ease;

            &:hover {
                background-color: rgba(#26a1e2, 0.2);
            }
        }
    }
}
</style>
